import { useContext, useState } from "react"
import { switchh } from "../../context/switch";
import '../../style/components/returns.css';
import { secondarySearch } from "../indexDB/indexDBStora";
import { context } from "../../context/context";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export default function Returns () {
    const {setEnableReturns, enableReturns, initialReturn } = useContext(switchh);
    const { t } = useTranslation();
    const { setCart } = useContext(context);
    const [orderNumber, setOrderNumber] = useState("");
    const getOrder = async (e) => {
        e.preventDefault();
        if(isNaN(orderNumber)) {
            return toast.error(t("error:return.NaN"));
        }
        const getDaOrders = await secondarySearch("invoices", "endDay", 'f');
        if(getDaOrders.length === 0) {
            return toast.error(t("error:return.noInvoice"));
        }
        const getSpecificOrder = getDaOrders.find((item) => item.order_number === Number(orderNumber));
        if(!getSpecificOrder || getSpecificOrder.returned) {
            return toast.error(t("error:return.noInvoice"));
        }
        setCart(getSpecificOrder?.data);
        setEnableReturns((prev) => ({...prev, 
            btn: true,
            order: getSpecificOrder
        }));
    }

    const reset = () => {
        setCart([]);
        setEnableReturns(initialReturn);
    }

    return (
        <div className="returns">
            <button onClick={() => reset()}>x</button>
            <form onSubmit={getOrder}>
                <input
                    min={1}
                    autoFocus={enableReturns}
                    value={orderNumber} 
                    onChange={(e) => setOrderNumber(e.target.value)} 
                    type="number" 
                    placeholder={t("placeholder:pos.searchOrder")}
                />
                <button>{t("action:search")}</button>
            </form>
        </div>
    )
}